import { mapGetters } from "vuex"
import orderBy from "lodash/orderBy"

import has_addresses from "../../mixins/HasAddresses"
import string_utilities from "../../mixins/StringUtilities"

const handles_project_requests = {
    mixins: [has_addresses, string_utilities],
    methods: {
        user_by_id (user_id) {
            return this.entity_record("user", user_id) || { initials: user_id }
        },
        current_physical_address_for_record (record) {
            if(!record) return null
            return this.physical_address("App\\ProjectRequest", record.id)
        },
        record_is_draft (record) {
            const current_physical_address = this.current_physical_address_for_record(record)
            return !record || !record.name || !record.additional_info || !current_physical_address || (!current_physical_address.state && !current_physical_address.city) || !record.firm_id || !record.starts_at || !record.due_at
        },
        copy_record (record) {
            if(!record) return

            const firm_name_by_id = firm_id => {
                if(!firm_id) return ""
                const firm = this.entity_record("firm", firm_id)
                return firm ? firm.name : ""
            }
            const term_name_by_id = (dictionary, term_id) => {
                if(!term_id) return ""
                const term = this.dictionary(dictionary).find(term => term.id === term_id)
                return term ? term.name : term_id
            }
            const bool_to_string = boolean => {
                return boolean ? "Yes" : "No"
            }
            const date_to_string = (date, format = "MM-YYYY") => {
                if(!date) return ""
                return this.$moment(date).format(format)
            }
            /*
            const other_recipients = record.other_recipient_ids.map((recipient_id) => {
                return this.user_by_id(recipient_id).initials
            })
            */
            const project_types = record.category_ids.map(category_id => {
                const category = this.entity_record("category", category_id)
                return category ? category.name : category_id
            }).filter(name => !!name).join(", ")
            const phases = []
            for(const phase in record.additional_info.schedule) {
                const date = date_to_string(record.additional_info.schedule[phase])
                if(date) phases.push(`${phase.toUpperCase()}: ${date}`)
            }
            const requests_for_materials = []
            if(record.additional_info.requests_for_materials) {
                if(!record.additional_info.requests_for_materials.length) requests_for_materials.push("Team only")
                else {
                    const request_types = this.request_types
                    record.additional_info.requests_for_materials.forEach(request_type_id => {
                        const request_type = request_types.find(request_type => request_type.id === request_type_id)
                        requests_for_materials.push(request_type ? request_type.name : request_type_id)
                    })
                }
            }
            const summary = []
            const summarize = (label, value) => {
                if(label === "HEADER") {
                    summary.push("")
                    summary.push(value)
                    // summary.push("")
                } else if(value && (value !== "No")) {
                    if(label) summary.push(`${label} ${value}`)
                    else summary.push(value)
                }
            }
            // summarize("Champion:", this.user_by_id(record.champion_id).initials)
            // summarize("Who else got the email?", other_recipients)
            summarize("", record.name.toUpperCase())
            summarize("", `${document.location.origin}/project_request/${record.id}`)

            summarize("Location:", record.physical_address_short_label)
            summarize("Client:", firm_name_by_id(record.firm_id))
            summarize("Owner:", firm_name_by_id(record.additional_info.owner_id))
            summarize("Confidential?", bool_to_string(record.confidential))
            summarize("Estimated Fee:", record.estimated_fee)
            summarize("Project Size:", record.size ? this.nibnut_filter("nibnut.concat", [[record.size || null, record.size_units]]) : "")
            summarize("Construction Cost:", record.additional_info.estimated_construction_cost ? `$ ${this.nibnut_filter("nibnut.number", [record.additional_info.estimated_construction_cost, "0,0"])}` : "")
            summarize("Project Type:", project_types)
            summarize("HEADER", "SCHEDULE")
            summarize("Lam Start:", date_to_string(record.starts_at, "MM-DD-YYYY"))
            summarize("", phases.join("\r\n"))
            summarize("HEADER", "REQUESTS FOR MATERIAL")
            // summarize("Requests for Material:", requests_for_materials.join(", "))
            summarize("", requests_for_materials.join(", "))
            summarize("Content Due by:", date_to_string(record.due_at, "MM-DD-YYYY"))
            if(
                !!record.additional_info.primary_deliverable ||
                !!record.additional_info.pro_bono ||
                !!record.additional_info.has_other_teams ||
                !!record.additional_info.pursue ||
                !!record.additional_info.extenuating_circumstances ||
                !!record.additional_info.other_info
            ) {
                summarize("HEADER", "ADDITIONAL DATA")
                summarize("Primary Deliverable:", term_name_by_id("primary_deliverable", record.additional_info.primary_deliverable))
                summarize("Pro-bono?", bool_to_string(record.additional_info.pro_bono))
                summarize("On multiple teams?", bool_to_string(record.additional_info.has_other_teams))
                summarize("Did we pursue?", bool_to_string(record.additional_info.pursue))
                summarize("Extenuating Circumstances?", bool_to_string(record.additional_info.extenuating_circumstances))
                if(record.additional_info.other_info) {
                    summary.push("Other Information:")
                    summary.push(record.additional_info.other_info)
                }
            }

            this.$clipboard(summary.join("\r\n"))
            this.$success("Copied to clipboard!")
        }
    },
    computed: {
        ...mapGetters(["entity_record"]),
        request_types () {
            return orderBy(this.dictionary("request_for_material"), [term => {
                if(term.name.match(/^other$/i)) return "zzzzzOther"
                return term.name
            }], "asc")
        }
    }
}

export default handles_project_requests
